// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"styles_aboutContainer__lwbKz","col":"styles_col__3G459","aboutGetStarted":"styles_aboutGetStarted__1jLWc","imagePH":"styles_imagePH__3Fq8p"};